//LinkedIn Learning: Learning Full-Stack Javascript Development: MongoDB, Node, and React
//import React, logo, App, ContactList, Button, ButtonToolbar, BrowserRouter, ContactsAPI

import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import 'quill/dist/quill.snow.css';
import {getFromStorage, setInStorage, removeItem} from './utils/storage.js'
import Login from './components/Login';
import Register from './components/Register';
import VerifySuccess from './components/VerifySuccess';
import Navigation from './components/Navigation.js';
import UserList from './components/UserList';
import {BrowserRouter as Router, Route, Link, Redirect} from 'react-router-dom';

import ViewDocumentList from './components/ViewDocumentList';
import ViewPrivacyPolicy from './components/ViewPrivacyPolicy';
import ViewSupport from './components/ViewSupport';

import * as ContactsAPI from './utils/ContactsAPI';


//Function imports
import * as Users from './functions/Users';
import * as LogInLogOut from './functions/LogInLogOut';


class App extends Component {
  constructor(props){
    super(props);

    this.state = {

      loggedInUser: {},
      users: [],


      selectedUser: {},


      contacts: [],

      isAuthenticated: false,
      isLoading: false,
      sessionIsLoading: true,
      incorrectPasswordUser: false,
      
      userLoggedInID: "",
      userType: "",
      userOrganization: "",
      userTeam: "",
      userFirstName: "",
      userLastName: "",
      userLifeExpectancy: "",
      userBirthDate: "",

      pathName: "/lifeclocksettings",
    }

    this.newUser = Users.newUser.bind(this);
    this.registerUser = Users.registerUser.bind(this);
    this.editUser = Users.editUser.bind(this);
    this.viewUser = Users.viewUser.bind(this);
    this.deleteUser = Users.deleteUser.bind(this);


    this.signInUser = LogInLogOut.signInUser.bind(this);
    this.logOut = LogInLogOut.logOut.bind(this);
    //this.verifyUser = this.verifyUser.bind(this);

    this.authenticate = LogInLogOut.authenticate.bind(this);


  }

  componentDidMount(){

    const obj= getFromStorage('the_main_app')

    console.log(`storage object ${JSON.stringify(obj)}`);
    //console.log(`storage object sessionId ${obj.sessionID}`);

    if (obj && obj.sessionID){

      //verify the token
      console.log(`There is an object in storage ${obj.sessionID} and ${obj.token}`);

      ContactsAPI.verifyUser(obj.sessionID).then((res) => {
        console.log("Response from verify API");
        console.log(`Response form verify API, response.success ${JSON.stringify(res)}`);

        if(res.success){
          console.log(`is Authenticated: 1 ${this.state.isAuthenticated}`)

          this.authenticate()
          this.setState({sessionIsLoading: false})
          this.setState({userType: obj.userType})
          this.setState({userOrganization: obj.userOrganization})
          this.setState({userTeam: obj.userTeam})
          this.setState({userFirstName: obj.userFirstName})
          this.setState({userLastName: obj.userLastName})
          this.setState({userLoggedInEmail: obj.userID})
          this.setState({userLoggedInID: obj.userID})

          
          console.log(`ID of the user logged in: ${this.state.userLoggedInID}`)
          console.log(`is Authenticated: ${this.state.isAuthenticated}`)

           ContactsAPI.getUsers(obj.jwt).then((users) => {
            console.log(`Users downloaded: ${JSON.stringify(users)}`);
              this.setState({users: users});

          });
          
          ContactsAPI.getUserWithEMail(obj.jwt, obj.userID).then((user) => {
            console.log(`contacts downloaded: ${JSON.stringify(user)}`);
              this.setState({loggedInUser: user});

            console.log(`loggedInUser state after getUserWithEMail: ${JSON.stringify(this.state.loggedInUser)}`);
       
          });


         this.fetchUserLifeClockData = async (obj) => {
            try {
                const lifeClockData = await ContactsAPI.getUserLifeClockData(obj.jwt, obj.userID);
                console.log(`Life expectancy downloaded: ${JSON.stringify(lifeClockData)}`);
        
                this.setState({
                    userLifeExpectancy: lifeClockData.userLifeExpectancy,
                    userBirthDate: lifeClockData.userBirthDate
                }, () => {
                    console.log(`Life expectancy state: ${this.state.userLifeExpectancy}`);
                    const birthdate = new Date(this.state.userBirthDate);
                    if (!isNaN(birthdate.getTime())) { // Check if it's a valid date
                        console.log(`Birthdate state: ${birthdate.toLocaleDateString("en-US")}`);
                    } else {
                        console.log("Birthdate state: Invalid date");
                    }
                });
        
            } catch (error) {
                console.error("Error fetching life clock data:", error);
            }
        };
        
        // Call the function in a lifecycle method or an event handler
        this.fetchUserLifeClockData(obj);

          return "Successful response!!!"
        }
      })
    }else{
      this.setState({sessionIsLoading: false})
    }

    setInterval( () => {
      const obj= getFromStorage('the_main_app')
      console.log(`storage object ${JSON.stringify(obj)}`);
      //console.log(`storage object sessionId ${obj.sessionID}`);
        if (obj && obj.sessionID){

          console.log(`Inside setInterval`);
         
        }
    },60000)
  }


  render(){
    return(
      <Router>
        <div>
            <Navigation userType={this.state.userType} isAuthenticated={this.state.isAuthenticated} logOut={this.logOut}/>
            <Route exact strict path="/" render={() => (
                <Redirect to={this.state.pathName}/>
            )}/>

            <Route exact strict path="/" render={() => (
              <div className="App">
                <header className="App-header">
                  <img src={logo} className="App-logo" alt="logo" />
                  <p>
                    Edit <code>src/App.js</code> and save to reload.
                  </p>
                  <a
                    className="App-link"
                    href="https://reactjs.org"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn React
                  </a>
                </header>
              </div>
            )}/>

                  
            <Route path="/login" render={() => (
              <Login sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} signInUser={this.signInUser} isAuthenticated={this.state.isAuthenticated}/>
            )}/>

            <Route path="/register" render={() => (
              
              <Register  registerUser={this.registerUser}/>
            )}/>

            <Route path="/verifysuccess" render={() => (
              <VerifySuccess/>
            )}/>

            <Route path="/viewprivacypolicy" render={() => (
              <ViewPrivacyPolicy loggedInUser={this.state.loggedInUser} userLifeExpectancy={this.state.userLifeExpectancy} userBirthDate={this.state.userBirthDate} editUser={this.editUser} viewUser={this.viewUser} userType={this.state.userType} documents={this.state.documents} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} markets={this.state.markets} selectedMarket={this.state.selectedMarket} newMarket={this.newMarket} newDocument={this.newDocument}
              selectedDocument={this.selectedDocument} selectedPage={this.selectedPage} editMarket={this.editMarket} viewMarket={this.viewMarket} viewDocument={this.viewDocument} viewPage={this.viewPage} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail} userOrganization={this.state.userOrganization} userFirstName={this.state.userFirstName}/>
            )}/>

            <Route path="/viewsupport" render={() => (
              <ViewSupport loggedInUser={this.state.loggedInUser} userLifeExpectancy={this.state.userLifeExpectancy} userBirthDate={this.state.userBirthDate} editUser={this.editUser} viewUser={this.viewUser} userType={this.state.userType} documents={this.state.documents} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} markets={this.state.markets} selectedMarket={this.state.selectedMarket} newMarket={this.newMarket} newDocument={this.newDocument}
                  selectedDocument={this.selectedDocument} selectedPage={this.selectedPage} editMarket={this.editMarket} viewMarket={this.viewMarket} viewDocument={this.viewDocument} viewPage={this.viewPage} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail} userOrganization={this.state.userOrganization} userFirstName={this.state.userFirstName}/>
            )}/>

            <Route path="/lifeclocksettings" render={() => (
              this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
                  <ViewDocumentList loggedInUser={this.state.loggedInUser} userLifeExpectancy={this.state.userLifeExpectancy} userBirthDate={this.state.userBirthDate} editUser={this.editUser} viewUser={this.viewUser} userType={this.state.userType} documents={this.state.documents} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} markets={this.state.markets} selectedMarket={this.state.selectedMarket} newMarket={this.newMarket} newDocument={this.newDocument}
                  selectedDocument={this.selectedDocument} selectedPage={this.selectedPage} editMarket={this.editMarket} viewMarket={this.viewMarket} viewDocument={this.viewDocument} viewPage={this.viewPage} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail} userOrganization={this.state.userOrganization} userFirstName={this.state.userFirstName}/>
              ) : (
                <Redirect to="/login"/>
              )
            )}/>

            <Route path="/userlistedit" render={() => (
              this.state.isAuthenticated || this.state.sessionIsLoading ? (
                <UserList users={this.state.users} selectedMarket={this.state.selectedMarket} newUser={this.newUser}
                editContact={this.editContact} viewUser={this.viewUser} deleteUser={this.deleteUser}/>
                ) : (
                  <Redirect to="/login"/>
                )
            )}/>


        </div>
      </Router>
    )
  }
}

export default App;





















/*
<Route path="/documentlist" render={() => (
              this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
                  <DocumentListAdmin documents={this.state.documents} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} markets={this.state.markets} selectedMarket={this.state.selectedMarket} newMarket={this.newMarket} newDocument={this.newDocument}
                  editMarket={this.editMarket} viewMarket={this.viewMarket} viewDocument={this.viewDocument} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail} userOrganization={this.state.userOrganization} userFirstName={this.state.userFirstName}/>
              ) : (
                <Redirect to="/login"/>
              )
            )}/>


  <Route path="/pagelist" render={() => (
  this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
      <PageList pages={this.state.pages} documents={this.state.documents} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} markets={this.state.markets} selectedMarket={this.state.selectedMarket} newMarket={this.newMarket} newPage={this.newPage} newDocument={this.newDocument}
      editMarket={this.editMarket} viewPage={this.viewPage} viewDocument={this.viewDocument} deleteMarket={this.deleteMarket} deletePage={this.deletePage} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail}/>
  ) : (
    <Redirect to="/login"/>
  )
  )}/>


  <Route path="/edituseradmin" render={() => (
  this.state.isAuthenticated || this.state.sessionIsLoading ? (
    <EditUserAdmin users={this.state.users} selectedUser={this.state.selectedUser} newUser={this.newUser}
    editContact={this.editContact} viewUser={this.viewUser} editUser={this.editUser} deleteUser={this.deleteUser}/>
    ) : (
      <Redirect to="/login"/>
    )
)}/>

<Route path="/editdocumentlist" render={() => (
  this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
      <EditDocumentList documents={this.state.documents} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} markets={this.state.markets} selectedMarket={this.state.selectedMarket} newMarket={this.newMarket} newDocument={this.newDocument}
      editMarket={this.editMarket} viewPage={this.viewPage} viewMarket={this.viewMarket} viewDocument={this.viewDocument} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail} userOrganization={this.state.userOrganization} userFirstName={this.state.userFirstName} nodes={this.state.nodes}/>
  ) : (
    <Redirect to="/login"/>
  )
  )}/>



   <Route path="/viewdocument" render={() => (
    this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
      this.state.selectedPage._id !== undefined ? (
        <ViewDocument documents={this.state.documents} comments={this.state.comments} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} pages={this.state.pages} selectedDocument={this.state.selectedDocument} selectedPage={this.state.selectedPage} newMarket={this.newMarket} newDocument={this.newDocument} newChildPage={this.newChildPage} userFirstName={this.state.userFirstName} userLastName={this.state.userLastName} userTeam={this.state.userTeam} newChildComment={this.newChildComment} documentPDF={this.state.documentPDF} getPDFWithId={this.getPDFWithId}
        editMarket={this.editMarket} editPage={this.editPage} editDocument={this.editDocument} viewMarket={this.viewMarket} viewDocument={this.viewDocument} viewPage={this.viewPage} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail} userOrganization={this.state.userOrganization} newComment={this.newComment}/>
      ) : (<Redirect to="/viewdocumentlist"/>)
    ) : (
      <Redirect to="/login"/>
    )
  )}/>


  <Route path="/editpageadmin" render={() => (
  this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
    this.state.selectedPage._id !== undefined ? (
      <EditPageAdmin documents={this.state.documents} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} pages={this.state.pages} selectedDocument={this.state.selectedDocument} selectedPage={this.state.selectedPage} newMarket={this.newMarket} newDocument={this.newDocument} newChildPage={this.newChildPage}
        editMarket={this.editMarket} editPage={this.editPage} editDocument={this.editDocument} viewMarket={this.viewMarket} viewDocument={this.viewDocument} viewPage={this.viewPage} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} deletePage={this.deletePage} sendEMail={this.sendEMail}/>
    ) : (<Redirect to="/viewdocumentlist"/>)
  ) : (
    <Redirect to="/login"/>
  )
)}/>



  <Route path="/editdocumentadmin" render={() => (
    this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
      this.state.selectedDocument._id !== undefined ? (
        <EditDocumentAdmin documents={this.state.documents} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} pages={this.state.pages} selectedDocument={this.state.selectedDocument} newPage={this.newPage} newDocument={this.newDocument}
        editDocument={this.editDocument} editMarket={this.editMarket} viewMarket={this.viewMarket} viewDocument={this.viewDocument} viewPage={this.viewPage} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} deletePage={this.deletePage} sendEMail={this.sendEMail}/>
      ) : (<Redirect to="/viewdocumentlist"/>)
    ) : (
      <Redirect to="/login"/>
    )
  )}/>



  <Route path="/editdocument" render={() => (
  this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
    this.state.selectedPage._id !== undefined ? (
// q: can you identify what in this EditDocument block is not being used in the EditDocument file?
// a: the following are not being used: this.state.selectedPage, this.state.selectedDocument, this.state.selectedContent, this.state.selectedUser, this.state.selectedMarket, this.state.selectedDeliverable, this.state.selectedContact
      <EditDocument documents={this.state.documents} comments={this.state.comments} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} pages={this.state.pages} selectedDocument={this.state.selectedDocument} selectedPage={this.state.selectedPage} newMarket={this.newMarket} newDocument={this.newDocument} newChildPage={this.newChildPage} userFirstName={this.state.userFirstName} userLastName={this.state.userLastName} userTeam={this.state.userTeam}
      editMarket={this.editMarket} editPage={this.editPage} updatePage={this.updatePage} editDocument={this.editDocument} viewMarket={this.viewMarket} viewDocument={this.viewDocument} viewPage={this.viewPage} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail} userOrganization={this.state.userOrganization} newComment={this.newComment}
      deletePage={this.deletePage} changeChildPageOrder={this.changeChildPageOrder}/>
    ) : (<Redirect to="/viewdocumentlist"/>)
  ) : (
    <Redirect to="/login"/>
  )
)}/>



  <Route path="/reactflow" render={() => (
  this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
    this.state.selectedPage._id !== undefined ? (
      <div style={{ height: 800 }}>
      <ReactFlowWrapper documents={this.state.documents} comments={this.state.comments} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} pages={this.state.pages} selectedDocument={this.state.selectedDocument} selectedPage={this.state.selectedPage} newMarket={this.newMarket} newDocument={this.newDocument} newChildPage={this.newChildPage} userFirstName={this.state.userFirstName} userLastName={this.state.userLastName} userTeam={this.state.userTeam}
      editMarket={this.editMarket} editPage={this.editPage} updatePage={this.updatePage} editDocument={this.editDocument} viewMarket={this.viewMarket} viewDocument={this.viewDocument} viewPage={this.viewPage} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail} userOrganization={this.state.userOrganization} newComment={this.newComment}
      deletePage={this.deletePage} changeChildPageOrder={this.changeChildPageOrder} nodes={this.state.nodes} />
      </div>
    ) : (<Redirect to="/viewdocumentlist"/>)
  ) : (
    <Redirect to="/login"/>
  )
  )}/>



    <Route path="/editpage/:page_id" render={(props) => (
        this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
            <EditDocumentNew
                page_id={props.match.params.page_id}
                documents={this.state.documents}
                comments={this.state.comments}
                pages={this.state.pages}
                incorrectPasswordUser={this.state.incorrectPasswordUser}
                isAuthenticated={this.state.isAuthenticated}
                sessionIsLoading={this.state.sessionIsLoading}
                isLoading={this.state.isLoading}
                newChildPage={this.newChildPage}
                addChildPage={this.addChildPage}
                editPage={this.editPage}
                changeChildPageOrder={this.changeChildPageOrder}
                deletePage={this.deletePage}
                newComment={this.newComment}
                newChildComment={this.newChildComment}
                userOrganization={this.state.userOrganization}
                userTeam={this.state.userTeam}
                userFirstName={this.state.userFirstName}
                viewPage={this.viewPage}

                removeChildPage={this.removeChildPage}
            />
        ) : (
            <Redirect to="/login"/>
        )
    )}/>



    <Route path="/viewdocument" render={() => (
  this.state.isAuthenticated || this.state.isLoading || this.state.sessionIsLoading ? (
    this.state.selectedPage._id !== undefined ? (
      <ViewDocument documents={this.state.documents} comments={this.state.comments} incorrectPasswordUser={this.state.incorrectPasswordUser} isAuthenticated={this.state.isAuthenticated} sessionIsLoading={this.state.sessionIsLoading} isLoading={this.state.isLoading} pages={this.state.pages} selectedDocument={this.state.selectedDocument} selectedPage={this.state.selectedPage} newMarket={this.newMarket} newDocument={this.newDocument} newChildPage={this.newChildPage} userFirstName={this.state.userFirstName} userLastName={this.state.userLastName} userTeam={this.state.userTeam} newChildComment={this.newChildComment} documentPDF={this.state.documentPDF} getPDFWithId={this.getPDFWithId}
      editMarket={this.editMarket} editPage={this.editPage} editDocument={this.editDocument} viewMarket={this.viewMarket} viewDocument={this.viewDocument} viewPage={this.viewPage} deleteMarket={this.deleteMarket} deleteDocument={this.deleteDocument} sendEMail={this.sendEMail} userOrganization={this.state.userOrganization} newComment={this.newComment}/>
    ) : (<Redirect to="/lifeclocksettings"/>)
  ) : (
    <Redirect to="/login"/>
  )
)}/>



*/
